import { routes } from "@/routes/utils";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { ZONE_NAME, DESCRIPTION } from "./consts";
import { schema } from "./validations";
import { useAddDataMutation, useGetDataById } from "@/services";

const AddEdit = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Property Zone",
    moduleRoute: `${routes.masterData}/${routes.propertyZone}`,
    schema,
    defaultValues: { [ZONE_NAME]: "", [DESCRIPTION]: "" },
    nameFieldKey: ZONE_NAME,
    queryKeyToInvalidate: "property-zones",
    module: "property-zones",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useAddDataMutation,
  });

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Zone Name"
    />
  );
};

export default AddEdit;
